<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500"  >
      <template v-slot:activator="{ on }">
        <v-btn class="success" dark v-on="on">Add New Project</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Add a New Project</v-card-title>
       <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field v-model="title" label="Title" prepend-icon="folder" :rules="inputRules"></v-text-field>
          <v-textarea v-model="content" label="Information" prepend-icon="edit" :rules="inputRules"></v-textarea>
          <v-spacer></v-spacer>
 <v-menu max-width="290">
    <template v-slot:activator="{ on }">
        <v-text-field :value="due" label="Due date" prepend-icon="mdi-calendar-range" v-on="on"  :rules="inputRules"></v-text-field>
    </template>
    <v-date-picker v-model="due"></v-date-picker>
</v-menu>
          <v-spacer></v-spacer>
          <v-btn flat @click="submit" class="success mx-0 mt-3" :loading="loading">Add Project</v-btn>
        </v-form>
      </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import db from '@/fb'

export default {
  data() {
    return {
      title: '',
      content: '',
           due: null,
      menu: false,
       inputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
            loading: false,
      dialog: false
    }
  },
  methods: {
    submit() {
      if(this.$refs.form.validate()) {
            this.loading = true;
         const project = { 
          title: this.title,
          content: this.content,
          due: this.due,
          person: 'The Net Ninja',
          status: 'ongoing'
        }
        db.collection('projects').add(project).then(() => {
           this.loading = false;
          this.dialog = false;
           this.$emit('projectAdded')
        })
      }
    }
  }
}
</script>